/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Done_DescInputs */

const en_consult_done_desc = /** @type {(inputs: Consult_Done_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expect a reply within two working days.`)
};

const id_consult_done_desc = /** @type {(inputs: Consult_Done_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balasan datang dalam dua hari kerja.`)
};

/**
* | output |
* | --- |
* | "Expect a reply within two working days." |
*
* @param {Consult_Done_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_done_desc = /** @type {((inputs?: Consult_Done_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Done_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_done_desc(inputs)
	return en_consult_done_desc(inputs)
});